import { Component, OnChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Subscription } from 'rxjs/internal/Subscription';
import { DQOIReferenceDataQuery } from '../../dqoi/state/dqoi-reference-data.query';
import { BaseAppMComponent } from '../../shared/base-components/base-app-m.component';
import { BaseMessageInfo } from '../../shared/models/BaseMessageInfo';
import { InventoryBus } from '../../shared/models/InventoryBus';
import { InvoiceLinesPricingAdjustmentBus } from '../../shared/models/InvoiceLinesPricingAdjustmentBus';
import { MonthDisplay } from '../../shared/models/MonthDisplay';
import { PricingItem } from '../../shared/models/PricingItem';
import { PricingProjectionDetail } from '../../shared/models/PricingProjectionDetail';
import { PricingProjectionParam } from '../../shared/models/PricingProjectionParam';
import { PricingProjectionRollup } from '../../shared/models/PricingProjectionRollup';
import { PricingProjectionRollups } from '../../shared/models/PricingProjectionRollups';
import { GlobalsService } from '../../shared/services/globals.service';
import { InvoiceService } from '../../shared/services/invoice.service';
import { CommonFunctions } from '../../shared/static/common-functions';
import { process, CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { ICPLoader, UseCPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component( {
    selector: 'cp-price-change-benefit',
    templateUrl: './price-change-benefit.component.html',
    styleUrls: [ './price-change-benefit.component.scss' ]
} )
export class PriceChangeBenefitComponent extends BaseAppMComponent<InventoryBus, InvoiceService, null, null> implements OnChanges {
    compLoader: ICPLoader = this as any;
    detailGrid: boolean = false;
    gridState: string = '';
    _svc_data: InvoiceService;
    showChart: boolean = false;
    showGrid: boolean = true;
    dialogEdit: boolean = false;
    locationIds: string[];
    accountClassIds: string[];
    divisionIds: string[];

 //    this.allData2 = this.allData2.bind(this);
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, _qry_rd: DQOIReferenceDataQuery, svc_data: InvoiceService) {
        super(globals,featureFlagService, _qry_rd);
        this.allData2 = this.allData2.bind(this);
        this._svc_data = svc_data;
        this.pricingProjectionRollup =  new PricingProjectionRollup(null);
        this.pricingProjectionRollup.details = [];
      //  this.editForm.controls["customerId"].setValue("6b134961-0294-4970-8f49-3c87ef8a8310");
        this.editForm.controls["startDate"].setValue(new Date("7/1/2021"));
        var date = new Date();
        var d = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.editForm.controls["endDate"].setValue(new Date("3/31/2022"));
        var pricingItem = new PricingItem();
        pricingItem.code = "LAB";
        this.pricingItems.push(pricingItem);
        var pricingItem1 = new PricingItem();
        pricingItem1.code = "OTLAB";
        this.pricingItems.push(pricingItem1);
        var pricingItem2 = new PricingItem();
        pricingItem2.code = "DTLAB";
        this.pricingItems.push(pricingItem2);
        var pricingItem3 = new PricingItem();
        pricingItem3.code = "TT";
        this.pricingItems.push(pricingItem3);
        var pricingItem4 = new PricingItem();
        pricingItem4.code = "TRIP";
        this.pricingItems.push(pricingItem4);
        var pricingItem5 = new PricingItem();
        pricingItem5.code = "EE";
        this.pricingItems.push(pricingItem5);
        this.monthsInRange = this.getMonthsBetween(this.editForm.controls["startDate"].value, this.editForm.controls["endDate"].value);
        this.monthText = this.monthsInRange.map(a => a.display);
        this.onChangeDate(null);
    }
    public filter: CompositeFilterDescriptor;
    public filterTable: CompositeFilterDescriptor;

    public removePricingItem(code:string) {

        var index = this.pricingItems.findIndex(a => a.code == code);
        if (index >= 0) {
            this.pricingItems.splice(index, 1);

        }
    }

    itemStateDisabled(itemArgs) {
        return false;
    }

    public allData2(indata: ExcelExportData): ExcelExportData {
        if (!this.rawItems) this.rawItems = [];
        const result: ExcelExportData = {
            data: process(this.rawItems as any, {}).data,
        };
        return result;
    }
    public labelContent = (e: any) => {
        return "Label";
    }
    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'customerId': new UntypedFormControl(),
        'locationIds': new UntypedFormControl(),
        'accountClassIds': new UntypedFormControl(),
        'divisionIds': new UntypedFormControl(),
        'startDate': new UntypedFormControl(),
        'endDate': new UntypedFormControl(),
        'baseRateMonth': new UntypedFormControl(),
    });

    customerCBOChanged(item: any) {
        if (CommonFunctions.hasValue(item)) {

                    this.customerChanged(item.value);
            //            this.customerChanged(item.value);
        }
        else {
            this.customerChanged(null);
        }
    }
    baseRateMonthCBOChanged(item: any) {
        if (CommonFunctions.hasValue(item)) {

            this.calculateBaseValues(item.value);

        }

    }
    editQuantity: number = 0;
    editPrice: number = 0;
    editTotal: number = 0;
    editInvoiceLineId: string ="";

    editDialog(dataItem: any) {

        this.editQuantity = dataItem.quantity;
        this.editPrice = dataItem.price;
        this.editTotal = dataItem.amount;
        this.editInvoiceLineId = dataItem.invoiceLineId;

        this.dialogEdit = true;

    }
    public onQuantityChange(value: number): void {
        this.editPrice = this.editTotal / value;
    }

    public onPriceChange(value: number): void {
        this.editQuantity = this.editTotal / value;
    }
    editClose() {

        this.dialogEdit = false;

    }
    editSave() {
        this.showSpinner();
        var busObj = new InvoiceLinesPricingAdjustmentBus(null);
        busObj.quantity = this.editQuantity;
        busObj.price = this.editPrice;
        busObj.invoiceLineId = this.editInvoiceLineId;
        this._svc_data.saveInvoiceLinesPricingAdjustment(busObj).toPromise().then((info: BaseMessageInfo) => {
            if (!info.saveError) {
                var index = this.rawItems.findIndex(a => a.invoiceLineId == this.editInvoiceLineId);
                if (index >= 0) {
                    if (!this.rawItems[index].originalQuantity) {

                        this.rawItems[index].originalQuantity = this.rawItems[index].quantity;
                        this.rawItems[index].originalPrice = this.rawItems[index].price;
                    }
                    this.rawItems[index].quantity = this.editQuantity;
                    this.rawItems[index].price = this.editPrice;
                }
                this.dialogEdit = false;
                this.hideSpinner();
            }
            else {
                this.globals.notifyError("Save Encountered an Error: " + info.message, true);
                this.hideSpinner();
            }

        });
    }

    customerChanged(id: any, holdLocationChange: boolean = false) {
        this.location = null;
        let custId: any = id;
        if (CommonFunctions.hasValue(this.referenceData) && CommonFunctions.hasArrayValue(this.referenceData.locations) && CommonFunctions.hasValue(id)) {
            this.customer = this.referenceData.getCustomerDesc(id); // .customers.find(s => s.value === id).description;
            this.customerLocations = this.referenceData.locations.filter(e => e.category === id);
            this.customerGeoLocations = this.referenceData.locations.filter(e => e.category === id);
            this.locationIds = [];
        }
        else {
            this.customer = null;
            //  this.editForm.value.customerId = null;
            this.customerLocations = [];
            this.customerGeoLocations = [];
        }
         //this.sendDQOIMessage(this.customer, this.location);
    }
    startDate: Date = null;
    endDate: Date = null;
    public onChangeDate(value: Date): void {
        this.startDate = this.editForm.controls["startDate"].value;
        this.endDate = this.editForm.controls["endDate"].value;
        if (this.editForm && this.editForm.controls["startDate"].value && this.editForm.controls["endDate"].value) {

            this.monthsInRange = this.getMonthsBetween(this.editForm.controls["startDate"].value, this.editForm.controls["endDate"].value);
            this.editForm.controls["baseRateMonth"].setValue(this.monthsInRange[0].value);
        }
        else {

            this.monthsInRange = [];
            this.editForm.controls["baseRateMonth"].setValue(null);
        }

    }
    dialogActive = false;
    subs_pricingProjection: Subscription;
    pricingProjectionRollups: PricingProjectionRollups = new PricingProjectionRollups(null);
    pricingProjectionRollup: PricingProjectionRollup = new PricingProjectionRollup(null);
    rawItems: PricingProjectionDetail[]=[];
    public filterData() {
        var pricingProjectionParam = new PricingProjectionParam(this.editForm.value);
        var codes = this.pricingItems.map(a => a.code);
        pricingProjectionParam.billingCodes = String(codes);
        CommonFunctions.unsubscribe(this.subs_pricingProjection);
        this.showSpinner();
        this.subs_pricingProjection = this._svc_data.getPricingProjection(pricingProjectionParam).subscribe((info: BaseMessageInfo) => {
            //this.mainLoadingOff(true);
            this.pricingProjectionRollups = new PricingProjectionRollups(info.primaryReturn);
            if (this.pricingProjectionRollups.billingCodes && this.pricingProjectionRollups.billingCodes.length > 0) {

                this.pricingProjectionRollup = new PricingProjectionRollup(this.pricingProjectionRollups.billingCodes[0])
            }
            if (info.primaryReturn.rawItems && info.primaryReturn.rawItems.length > 0) {

                let arr = [];
                if (CommonFunctions.hasArrayValue(info.primaryReturn.rawItems)) {
                    for (let i = 0; i < info.primaryReturn.rawItems.length; i++) {
                        let newObj: PricingProjectionDetail = new PricingProjectionDetail(info.primaryReturn.rawItems[i]);
                        arr.push(newObj);
                    }
                }
                this.pricingProjectionRollups.rawItems = arr;
                this.rawItems = arr;
            }
            this.calculateBaseValues(this.editForm.controls["baseRateMonth"].value);
            this.calculateDelta();
            this.hideSpinner();
        });

    }
    showSpinner() {
        this.compLoader.cpLoaderOn();
    }

    hideSpinner() {
        this.compLoader.cpLoaderOff();
    }
    public showDialog() {

        this.dialogActive = true;
    }
    public cancel() {
        this.newLaborCode= null;
        this.dialogActive = false;
    }
    public filterDisabled() {
        if (!this.editForm || !this.editForm.controls || !this.editForm.controls["startDate"].value || !this.editForm.controls["endDate"].value || this.editForm.controls["endDate"].value < this.editForm.controls["startDate"].value) { return true; }
        return false;
    }
    public ok() {
        var i = this.laborCodes.findIndex(a => a.code === this.newLaborCode)
        if (i >= 0) {

            this.laborCodes[i].selected = true;
        }
        var pricingItem = new PricingItem();
        pricingItem.code = this.newLaborCode;
        this.pricingItems.push(pricingItem);
        this.dialogActive = false;
    }
    public  (itemArgs: { dataItem: any; index: number }) {
        return (itemArgs.dataItem.selected ); // disable the 3rd item
    }
    newLaborCode = "";
    pricingItems: PricingItem[] = [];
    laborCodes = [
        { selected: false, code: "DTAPLAB" },
        { selected: false, code: "DTHELP" },
        { selected: false, code: "DTLAB" },
        { selected: false, code: "DTRLAB" },
        { selected: false, code: "DTT" },
        { selected: false, code: "DTTHELP" },
        { selected: false, code: "DTTLAB" },
        { selected: false, code: "EE" },
        { selected: false, code: "HELP" },
        { selected: false, code: "INV" },
        { selected: false, code: "LAB" },
        { selected: false, code: "OTHELP" },
        { selected: false, code: "OTLAB" },
        { selected: false, code: "OTRAPPRLAB" },
        { selected: false, code: "OTRLAB" },
        { selected: false, code: "OTT" },
        { selected: false, code: "OTTHELP" },
        { selected: false, code: "OTTLAB" },
        { selected: false, code: "RAPPRLAB" },
        { selected: false, code: "RLAB" },
        { selected: false, code: "THELP" },
        { selected: false, code: "TLAB" },
        { selected: false, code: "TRIP" },
        { selected: false, code: "TT" },]
    monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    monthsInRange = [];
    monthText = [];
    getMonthsBetween(from, to) {
    var arr = [];
    var datFrom = new Date(from);
    var datTo = new Date(to);
    var fromYear = datFrom.getFullYear();
    var toYear = datTo.getFullYear();
    var diffYear = (12 * (toYear - fromYear)) + datTo.getMonth();

    for (var i = datFrom.getMonth(); i <= diffYear; i++) {
        var nitem = new MonthDisplay(null);
        nitem.display = this.monthNames[i % 12] + " " + Math.floor(fromYear + (i / 12));
        nitem.value = "" + Math.floor(fromYear + (i / 12)) + (i % 12).toString().padStart(2, '0');
        arr.push(nitem);
    }

    return arr;
}
    calculateBaseValues(monthValue) {
       var monthIndex = -1
        for (var i = 0; i < this.monthsInRange.length; i++) {
            if (this.monthsInRange[i].value == monthValue) {
                monthIndex = i;
            }
        }
        if (monthIndex >= 0) {
            for (var i = 0; i < this.pricingItems.length; i++) {
                var month = this.pricingProjectionRollups.billingCodes.find(a => a.billingCode == this.pricingItems[i].code);
                if (month) {
                    this.pricingItems[i].base = month.details[monthIndex].price;
                    this.pricingItems[i].newPrice = month.details[monthIndex].price;
                }
            }
        }
    }
    onBlur(event) {

        this.calculateDelta();
    }
    totals = [];
    calculateDelta() {
        var totals = [];
        for (var ii = 0; ii < this.monthsInRange.length; ii++) {
            totals.push(0.0);
        }
        var monthIndex = -1
        for (var i = 0; i < this.pricingItems.length; i++) {
            var billingCode = this.pricingProjectionRollups.billingCodes.find(a => a.billingCode == this.pricingItems[i].code);
            var totalHours = 0.0;
            var totalDiff = 0.0;

            for (var ii = 0; ii < billingCode.details.length; ii++) {
                if (billingCode.details[ii].quantity > 0) {
                    var priceDelta = (this.pricingItems[i].newPrice - billingCode.details[ii].price) * billingCode.details[ii].quantity;
                    billingCode.details[ii].delta = priceDelta;
                    totalDiff = totalDiff + priceDelta;
                    billingCode.details[ii].newAmount = (this.pricingItems[i].newPrice);
                    totals[ii] = totals[ii] + priceDelta;
                }

            }
            billingCode.values = billingCode.details.map(a => a.delta);
            this.pricingItems[i].impact = totalDiff;
        }
        this.totals = totals;
    }
    public gridChartButton(state){
        if (state == 'grid') {
            this.showChart = false;
            this.showGrid = true;
        } else {
            this.showChart = true;
            this.showGrid = false;
        }
    }
    //public showChartButton() {
    //        this.showChart = !this.showChart;
    //}

}
